import { api, secureCall } from 'utils/api';

const route = 'bonus';

export const getBonus = secureCall((params) => api.get(route, { params }));

export const updateBonus = secureCall((payload) => api.patch(`${route}/${payload.bonusId}`, payload));
